import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'barthauer-ascii-import',
    templateUrl: './ascii-import.component.html',
    styleUrls: ['./ascii-import.component.scss'],
    standalone: false
})
export class AsciiImportComponent implements OnInit {
  @ViewChild('wizard', { static: true }) wizard: any;
  constructor() {}

  ngOnInit(): void {}
}
